import { forwardRef } from 'react';
import { createPortal } from 'react-dom';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';
import { Typography } from '../Typography/index.js';

export type HintElement = FlexElement;
export interface HintProps extends FlexProps {
  portal?: Element | DocumentFragment;
}

export const Hint = styled(
  forwardRef<HintElement, HintProps>(
    ({ portal = document.body as Element, children, ...restProps }, fowardedRef) => {
      return createPortal(
        <Flex ref={fowardedRef} {...restProps}>
          {typeof children === 'string' ? (
            <Typography size="small" variant="label">
              {children}
            </Typography>
          ) : (
            children
          )}
        </Flex>,
        portal
      );
    }
  )
).withConfig({
  displayName: 'HintProps',
})`
  display: inline-flex;
  white-space: nowrap;
  padding: calc(var(--spacing-gap) / 2);
  background-color: var(--spz-sys-color-surface-container-highest);
  border: 1px solid var(--spz-sys-color-surface-container);
  border-radius: calc(var(--shape-rounded-radius) / 2);
  z-index: 10;
`;
